<template>
  <svg v-if="color_1"
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#insights_group_icon)">
      <path
        d="M4.125 17.25L1.5 22.5H6.75L4.125 17.25ZM19.5 11.25V12.75C20.3272 12.75 21 13.4227 21 14.25V18C21 18.8273 20.3272 19.5 19.5 19.5H7.5V21H19.5C21.1545 21 22.5 19.6545 22.5 18V14.25C22.5 12.5955 21.1545 11.25 19.5 11.25Z"
        fill="url(#insight_group_icon)" />
      <path
        d="M10.5 18C10.3371 17.9999 10.1787 17.9468 10.0486 17.8487C9.91861 17.7506 9.82404 17.6129 9.77925 17.4562L8.4345 12.75H6V11.25H9C9.16289 11.2501 9.32133 11.3032 9.45136 11.4013C9.58139 11.4994 9.67596 11.6371 9.72075 11.7937L10.5 14.52L12.7792 6.54375C12.8243 6.38736 12.9189 6.24985 13.0489 6.15197C13.1789 6.05409 13.3373 6.00116 13.5 6.00116C13.6627 6.00116 13.8211 6.05409 13.9511 6.15197C14.0811 6.24985 14.1757 6.38736 14.2208 6.54375L15.5655 11.25H18V12.75H15C14.8371 12.7499 14.6787 12.6968 14.5486 12.5987C14.4186 12.5006 14.324 12.3629 14.2792 12.2062L13.5 9.48L11.2208 17.4562C11.176 17.6129 11.0814 17.7506 10.9514 17.8487C10.8213 17.9468 10.6629 17.9999 10.5 18Z"
        fill="url(#insight_group_icon)" />
      <path
        d="M3 9.75V6C3 5.17275 3.67275 4.5 4.5 4.5H16.5V3H4.5C2.8455 3 1.5 4.3455 1.5 6V9.75C1.5 11.4045 2.8455 12.75 4.5 12.75V11.25C3.67275 11.25 3 10.5773 3 9.75Z"
        fill="url(#insight_group_icon)" />
      <path
        d="M20.25 6C21.4926 6 22.5 4.99264 22.5 3.75C22.5 2.50736 21.4926 1.5 20.25 1.5C19.0074 1.5 18 2.50736 18 3.75C18 4.99264 19.0074 6 20.25 6Z"
        fill="url(#insight_group_icon)" />
    </g>
    <defs>
      <linearGradient id="insight_group_icon"
                      x1="13"
                      y1="2.25"
                      x2="13"
                      y2="21.75"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="color_1" />
        <stop offset="1" :stop-color="color_2" />
      </linearGradient>
      <clipPath id="insights_group_icon">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg v-else
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.125 17.25L1.5 22.5H6.75L4.125 17.25ZM19.5 11.25V12.75C20.3272 12.75 21 13.4227 21 14.25V18C21 18.8273 20.3272 19.5 19.5 19.5H7.5V21H19.5C21.1545 21 22.5 19.6545 22.5 18V14.25C22.5 12.5955 21.1545 11.25 19.5 11.25Z"
      :fill="color" />
    <path
      d="M10.5 18C10.3371 17.9999 10.1787 17.9468 10.0486 17.8487C9.91861 17.7506 9.82404 17.6129 9.77925 17.4562L8.4345 12.75H6V11.25H9C9.16289 11.2501 9.32133 11.3032 9.45136 11.4013C9.58139 11.4994 9.67596 11.6371 9.72075 11.7937L10.5 14.52L12.7792 6.54375C12.8243 6.38736 12.9189 6.24985 13.0489 6.15197C13.1789 6.05409 13.3373 6.00116 13.5 6.00116C13.6627 6.00116 13.8211 6.05409 13.9511 6.15197C14.0811 6.24985 14.1757 6.38736 14.2208 6.54375L15.5655 11.25H18V12.75H15C14.8371 12.7499 14.6787 12.6968 14.5486 12.5987C14.4186 12.5006 14.324 12.3629 14.2792 12.2062L13.5 9.48L11.2208 17.4562C11.176 17.6129 11.0814 17.7506 10.9514 17.8487C10.8213 17.9468 10.6629 17.9999 10.5 18Z"
      :fill="color" />
    <path
      d="M3 9.75V6C3 5.17275 3.67275 4.5 4.5 4.5H16.5V3H4.5C2.8455 3 1.5 4.3455 1.5 6V9.75C1.5 11.4045 2.8455 12.75 4.5 12.75V11.25C3.67275 11.25 3 10.5773 3 9.75Z"
      :fill="color" />
    <path
      d="M20.25 6C21.4926 6 22.5 4.99264 22.5 3.75C22.5 2.50736 21.4926 1.5 20.25 1.5C19.0074 1.5 18 2.50736 18 3.75C18 4.99264 19.0074 6 20.25 6Z"
      :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "white"
    },
    color_1: null,
    color_2: null
  }
}
</script>
